// ==========================================
// SAVINGS DISPLAY - OPTIMIZED
// ==========================================
(function() {
  'use strict';
  
  let hasRun = false;
  let observer = null;
  
  function displaySavingsAmount() {
    // Prevent duplicate runs
    const subtitleElements = document.querySelectorAll('.mce-price-subtitle');
    
    if (subtitleElements.length === 0) return;
    
    subtitleElements.forEach((subtitle) => {
      const container = subtitle.closest('.mce-selector-item-container');
      if (!container) return;
      
      const priceWrapper = container.querySelector('.mce-price-wrapper');
      if (!priceWrapper) return;
      
      const discountPercentage = parseFloat(priceWrapper.dataset.discountPercentage);
      const quantity = parseInt(priceWrapper.dataset.qty);
      const finalPrice = parseFloat(priceWrapper.dataset.price);
      
      if (discountPercentage > 0) {
        const originalPricePerUnit = finalPrice / (1 - discountPercentage / 100);
        const totalOriginalPrice = originalPricePerUnit * quantity;
        const totalFinalPrice = finalPrice * quantity;
        const savingsAmount = totalOriginalPrice - totalFinalPrice;
        const formattedSavings = savingsAmount.toFixed(2);
        
        // Check if savings already exists
        if (!subtitle.querySelector('.savings-amount')) {
          const savingsText = document.createElement('span');
          savingsText.className = 'savings-amount';
          savingsText.style.cssText = 'color: black; font-weight: bold; margin-left: 5px;';
          savingsText.textContent = `(Save Rs.${formattedSavings})`;
          subtitle.appendChild(savingsText);
        }
      }
    });
    
    hasRun = true;
  }
  
  function init() {
    if (hasRun) return;
    
    // Try to run immediately
    displaySavingsAmount();
    
    // Only observe if elements not found yet
    if (!hasRun) {
      let debounceTimer;
      observer = new MutationObserver(function(mutations) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          displaySavingsAmount();
          
          // Disconnect observer after successful run
          if (hasRun && observer) {
            observer.disconnect();
            observer = null;
          }
        }, 300);
      });
      
      // Only observe the specific area where prices appear, not entire body
      const priceContainer = document.querySelector('.mce-selector-items-container') || document.body;
      observer.observe(priceContainer, { 
        childList: true, 
        subtree: true 
      });
      
      // Auto-disconnect after 10 seconds to prevent infinite observation
      setTimeout(() => {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
      }, 10000);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ==========================================
// REVIEWS SLIDER - OPTIMIZED
// ==========================================
(function() {
  'use strict';
  
  const CONFIG = {
    containerSelector: '.jdgm-rev-widg__reviews',
    reviewSelector: '.jdgm-rev',
    autoplayDelay: 5000,
    transitionDuration: 500,
    enableAutoplay: true,
    enableTouch: true,
    enableKeyboard: true
  };

  let currentIndex = 0;
  let autoplayTimer = null;
  let isTransitioning = false;
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  let isInitialized = false;
  let observer = null;

  function initSlider() {
    if (isInitialized) return;
    
    const container = document.querySelector(CONFIG.containerSelector);
    if (!container) return;

    const reviews = container.querySelectorAll(CONFIG.reviewSelector);
    if (reviews.length === 0) return;

    if (reviews.length === 1) {
      centerSingleReview(container, reviews[0]);
      isInitialized = true;
      disconnectObserver();
      return;
    }

    setupSliderStructure(container, reviews);
    setupControls(container, reviews.length);
    setupEventListeners(container, reviews.length);
    
    if (CONFIG.enableAutoplay) {
      startAutoplay(reviews.length);
    }

    isInitialized = true;
    disconnectObserver();
  }

  function centerSingleReview(container, review) {
    const wrapper = document.createElement('div');
    wrapper.className = 'jdgm-reviews-single-wrapper';
    wrapper.style.cssText = 'display: flex; justify-content: center; align-items: center; width: 100%; padding: 20px 0;';

    const reviewContainer = document.createElement('div');
    reviewContainer.style.cssText = 'max-width: 800px; width: 100%;';

    reviewContainer.appendChild(review);
    wrapper.appendChild(reviewContainer);
    container.appendChild(wrapper);
  }

  function setupSliderStructure(container, reviews) {
    const sliderWrapper = document.createElement('div');
    sliderWrapper.className = 'jdgm-reviews-slider-wrapper';
    sliderWrapper.style.cssText = 'position: relative; overflow: hidden; width: 100%; isolation: isolate;';

    const sliderTrack = document.createElement('div');
    sliderTrack.className = 'jdgm-reviews-slider-track';
    sliderTrack.style.cssText = `display: flex; transition: transform ${CONFIG.transitionDuration}ms ease-in-out; will-change: transform; width: 100%;`;

    reviews.forEach(review => {
      const slideWrapper = document.createElement('div');
      slideWrapper.className = 'jdgm-slide-wrapper';
      slideWrapper.style.cssText = 'min-width: 100%; max-width: 100%; width: 100%; flex-shrink: 0; display: flex; justify-content: center; align-items: flex-start; padding: 20px; box-sizing: border-box;';

      const reviewContainer = document.createElement('div');
      reviewContainer.style.cssText = 'max-width: 800px; width: 100%; box-sizing: border-box;';
      review.style.cssText = 'width: 100%; box-sizing: border-box; overflow: hidden;';

      reviewContainer.appendChild(review);
      slideWrapper.appendChild(reviewContainer);
      sliderTrack.appendChild(slideWrapper);
    });

    sliderWrapper.appendChild(sliderTrack);
    container.appendChild(sliderWrapper);
  }

  function setupControls(container, totalReviews) {
    const controlsHTML = `
      <div class="jdgm-slider-controls" style="display: flex; justify-content: center; align-items: center; gap: 20px; margin-top: 20px; padding: 0 20px; box-sizing: border-box;">
        <button class="jdgm-slider-btn jdgm-slider-prev" aria-label="Previous review" style="background: #333; color: white; border: none; border-radius: 50%; width: 40px; height: 40px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 18px; transition: background 0.3s ease; flex-shrink: 0;">‹</button>
        <div class="jdgm-slider-dots" style="display: flex; gap: 8px; flex-wrap: wrap; justify-content: center;"></div>
        <button class="jdgm-slider-btn jdgm-slider-next" aria-label="Next review" style="background: #333; color: white; border: none; border-radius: 50%; width: 40px; height: 40px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 18px; transition: background 0.3s ease; flex-shrink: 0;">›</button>
      </div>
    `;

    container.insertAdjacentHTML('beforeend', controlsHTML);

    const dotsContainer = container.querySelector('.jdgm-slider-dots');
    for (let i = 0; i < totalReviews; i++) {
      const dot = document.createElement('button');
      dot.className = 'jdgm-slider-dot';
      dot.setAttribute('aria-label', `Go to review ${i + 1}`);
      dot.dataset.index = i;
      dot.style.cssText = `width: 10px; height: 10px; border-radius: 50%; border: 2px solid #333; background: ${i === 0 ? '#333' : 'transparent'}; cursor: pointer; transition: background 0.3s ease; padding: 0; flex-shrink: 0;`;
      dotsContainer.appendChild(dot);
    }

    const buttons = container.querySelectorAll('.jdgm-slider-btn');
    buttons.forEach(btn => {
      btn.addEventListener('mouseenter', () => btn.style.background = '#555');
      btn.addEventListener('mouseleave', () => btn.style.background = '#333');
    });
  }

  function setupEventListeners(container, totalReviews) {
    const prevBtn = container.querySelector('.jdgm-slider-prev');
    const nextBtn = container.querySelector('.jdgm-slider-next');
    
    prevBtn.addEventListener('click', () => {
      if (!isTransitioning) goToSlide(currentIndex - 1, totalReviews);
    });

    nextBtn.addEventListener('click', () => {
      if (!isTransitioning) goToSlide(currentIndex + 1, totalReviews);
    });

    const dots = container.querySelectorAll('.jdgm-slider-dot');
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        if (!isTransitioning) goToSlide(parseInt(dot.dataset.index), totalReviews);
      });
    });

    if (CONFIG.enableTouch) {
      const wrapper = container.querySelector('.jdgm-reviews-slider-wrapper');
      wrapper.addEventListener('touchstart', handleTouchStart, { passive: true });
      wrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
      wrapper.addEventListener('touchend', () => handleTouchEnd(totalReviews));
      wrapper.addEventListener('mousedown', handleTouchStart);
      wrapper.addEventListener('mousemove', handleTouchMove);
      wrapper.addEventListener('mouseup', () => handleTouchEnd(totalReviews));
      wrapper.addEventListener('mouseleave', () => handleTouchEnd(totalReviews));
    }

    if (CONFIG.enableKeyboard) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') goToSlide(currentIndex - 1, totalReviews);
        else if (e.key === 'ArrowRight') goToSlide(currentIndex + 1, totalReviews);
      });
    }

    container.addEventListener('mouseenter', stopAutoplay);
    container.addEventListener('mouseleave', () => {
      if (CONFIG.enableAutoplay) startAutoplay(totalReviews);
    });
  }

  function goToSlide(index, totalReviews) {
    if (isTransitioning) return;

    if (index < 0) index = totalReviews - 1;
    else if (index >= totalReviews) index = 0;

    const container = document.querySelector(CONFIG.containerSelector);
    const track = container.querySelector('.jdgm-reviews-slider-track');
    const dots = container.querySelectorAll('.jdgm-slider-dot');

    isTransitioning = true;
    currentIndex = index;

    track.style.transform = `translateX(-${index * 100}%)`;
    dots.forEach((dot, i) => {
      dot.style.background = i === index ? '#333' : 'transparent';
    });

    setTimeout(() => { isTransitioning = false; }, CONFIG.transitionDuration);

    if (CONFIG.enableAutoplay) {
      stopAutoplay();
      startAutoplay(totalReviews);
    }
  }

  function handleTouchStart(e) {
    isDragging = true;
    startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
    currentX = startX;
  }

  function handleTouchMove(e) {
    if (!isDragging) return;
    currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
    const diff = currentX - startX;
    if (Math.abs(diff) > 10) e.preventDefault();
  }

  function handleTouchEnd(totalReviews) {
    if (!isDragging) return;
    isDragging = false;
    const diff = currentX - startX;
    const threshold = 50;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) goToSlide(currentIndex - 1, totalReviews);
      else goToSlide(currentIndex + 1, totalReviews);
    }
  }

  function startAutoplay(totalReviews) {
    stopAutoplay();
    autoplayTimer = setInterval(() => {
      goToSlide(currentIndex + 1, totalReviews);
    }, CONFIG.autoplayDelay);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  function disconnectObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function init() {
    if (isInitialized) return;
    
    // Try immediate initialization
    initSlider();
    
    // Only set up observer if not initialized
    if (!isInitialized) {
      let observerTimer;
      observer = new MutationObserver(() => {
        clearTimeout(observerTimer);
        observerTimer = setTimeout(() => {
          if (!isInitialized) initSlider();
        }, 500);
      });

      // Only observe the reviews container area, not entire body
      const reviewsArea = document.querySelector('.jdgm-rev-widg') || document.body;
      observer.observe(reviewsArea, {
        childList: true,
        subtree: true
      });

      // Auto-disconnect after 10 seconds
      setTimeout(disconnectObserver, 10000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();